'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var RM = require('./model');
var Category = require('../constant/category');
var Event = require('../util/event');
var Logger = require('../util/logger');
var Global = require('../util/global');
var Logan = require('../util/logan');

var NAME = 'resource';

var CACHE_SEND_TRIGGER = 10;
var isSupportGetEntry = window.performance && window.performance.getEntries !== undefined;
/**
 * 统一图片的URL路径
 * @param {string} url 
 */
var getImageDomain = function getImageDomain(url) {
    var arr = url.split('//');
    if (arr && arr.length > 1) {
        return arr[0] + '//' + arr[1].split('/')[0] + '/images';
    }
};

/**
 * 接口管理类
 * 
 * @class ResManager
 */

var ResManager = function () {
    /**
     * Creates an instance of ResManager.
     * @param {CfgManager} cfgManager 
     * @param {ErrorManager} errManager 
     * @memberof ResManager
     */
    function ResManager(cfgManager, errManager) {
        _classCallCheck(this, ResManager);

        this.cfgManager = cfgManager;
        this.errManager = errManager;
        this.cache = [];
        this.entryCache = [];
        this.comboTimeout = 0;
    }
    /**
     * 解析AJAX监控数据
     * 
     * @param {Event} event 
     * @returns 
     * @memberof ResManager
     */


    _createClass(ResManager, [{
        key: 'parseAjax',
        value: function parseAjax(event) {
            var state = void 0;
            var url = void 0;
            var duration = void 0;
            var byte = void 0;
            var statusCode = void 0;
            try {
                state = event.type;
                url = event.currentTarget.responseURL || event.currentTarget.url;
                duration = event.duration;
                byte = event.total;
                statusCode = event.currentTarget.status;
            } catch (e) {
                return e;
            }
            if (duration === undefined || isNaN(duration)) {
                return;
            }

            var isSuccess = state === 'load' || state === 'readystatechange' && statusCode === 200;

            this.addLogan('AJAX', url);

            if (url.indexOf('//') === 0) {
                url = Global.getProtocol() + url;
            } else if (url.indexOf('/') === 0) {
                url = Global.getOrigin() + url;
            }

            statusCode = (isSuccess ? 200 : 500) + '|';

            var cfgManager = this.cfgManager;
            var isAjaxUseful = true;
            try {
                var ajaxIgoreList = cfgManager.get('ignoreList').ajax;
                if (ajaxIgoreList) {
                    for (var index = 0; index < ajaxIgoreList.length; index++) {
                        var regStr = ajaxIgoreList[index];
                        var ajaxReg = new RegExp(regStr);
                        if (ajaxReg.test(url)) {
                            isAjaxUseful = false;
                            return;
                        }
                    }
                }
            } catch (e) {
                Logger.ignore(e);
            }

            if (!isAjaxUseful) return;

            var resourceReg = cfgManager.get('resourceReg');
            var isUrlValid = cfgManager.get('devMode') || resourceReg instanceof RegExp && cfgManager.get('resourceReg').test(url);

            if (isUrlValid) {
                if (!cfgManager.get('ajax').flag || duration < cfgManager.get('ajax').duration) {
                    this.pushApi({
                        type: 'ajax',
                        resourceUrl: url,
                        responsetime: duration,
                        responsebyte: byte,
                        statusCode: statusCode,
                        firstCategory: isSuccess ? '' : Category.AJAX
                    });
                } else {
                    this.errManager.push({
                        name: 'TIMEOUT_AJAX',
                        msg: 'ajax\u8BF7\u6C42\u65F6\u95F4\u8D85\u8FC7\u8BBE\u5B9A' + url
                    }, {
                        category: Category.AJAX
                    });
                }
            } else if (cfgManager.get('invalid').ajax && Math.random() < 0.1) {
                this.errManager.push({
                    name: 'INVALID_AJAX',
                    msg: url
                }, {
                    category: Category.AJAX
                });
            }
        }
    }, {
        key: 'filterResource',
        value: function filterResource(url) {
            var isUseful = true;
            var resourceFilters = this.cfgManager.get('ignoreList').resource;
            try {
                for (var index = 0; index < resourceFilters.length; index++) {
                    var regStr = resourceFilters[index];
                    var resourceReg = new RegExp(regStr);
                    if (resourceReg.test(url)) {
                        isUseful = false;
                        break;
                    }
                }
                return isUseful;
            } catch (e) {
                Logger.ignore(e);
                return isUseful;
            }
        }
        /**
         * 解析performance.getEntries下面的资源性能
         * 
         * @memberof ResManager
         */

    }, {
        key: 'doHandlePerformanceEntry',
        value: function doHandlePerformanceEntry(entries) {
            entries = this.filterEntry(entries);
            if (!entries || !entries.length) return;

            var cfgManager = this.cfgManager;
            var entryCache = this.entryCache;

            for (var i = 0; i < entries.length; i++) {
                var entry = entries[i];
                var url = entry.name;

                var isUrlUseful = this.filterResource(url);

                if (!isUrlUseful) return;

                if (cfgManager.get('devMode') || cfgManager.get('resourceReg').test(url)) {
                    entryCache.push(url);
                    var statusCode = '200|';
                    var imgConfig = cfgManager.get('image');
                    var isError = false;

                    if ((entry.initiatorType === 'img' || entry.initiatorType === 'css') && imgConfig.flag) {
                        var imageUrl = entry.name;
                        var filter = imgConfig.filter;

                        if (typeof filter === 'function' && !filter(imageUrl)) {
                            //图片资源
                            var transferSize = entry.transferSize;
                            var duration = entry.duration;
                            var sec_category = void 0;
                            if (transferSize && transferSize > imgConfig.fileSize * 1000) {
                                sec_category = 'IMAGE_SIZE_EXCEED';
                            } else if (duration && duration > imgConfig.duration) {
                                sec_category = 'IMAGE_DURATION_EXCEED';
                            }
                            if (sec_category) {
                                this.errManager._pushResource({
                                    content: imageUrl,
                                    sec_category: sec_category
                                }, {
                                    category: Category.RESOURCE
                                });
                                isError = true;
                            }
                        }
                    }
                    if (!isError) {
                        this.push({
                            type: entry.initiatorType,
                            resourceUrl: entry.initiatorType === 'img' ? getImageDomain(url) : url,
                            responsebyte: entry.transferSize,
                            responsetime: entry.duration,
                            statusCode: statusCode
                        });
                    }
                }
            }

            this.report();
        }
    }, {
        key: 'filterEntry',
        value: function filterEntry(entries) {
            var ret = [];
            for (var index = 0; index < entries.length; index++) {
                var entry = entries[index];
                if (['link', 'script', 'img', 'css'].indexOf(entry.initiatorType) !== -1) {
                    ret.push(entry);
                }
            }
            return ret;
        }

        /**
         * 检测performance中新增的entry
         * @override
         * @memberof ResManager
         */

    }, {
        key: 'observePerformanceChange',
        value: function observePerformanceChange() {
            var _this = this;

            // observe once
            if (this.observePerformance) {
                return;
            } else {
                this.observePerformance = true;
            }

            if (window.PerformanceObserver) {
                var observer = new window.PerformanceObserver(function (list) {
                    try {
                        var entries = list.getEntries();
                        _this.doHandlePerformanceEntry(entries);
                    } catch (e) {
                        Logger.ignore(e);
                    }
                });
                observer.observe({
                    entryTypes: ['resource']
                });
            } else {
                //  通过ajax的拦截动态检查更新
                Event.on('ajaxCall', function () {
                    setTimeout(function () {
                        var entryCache = _this.entryCache;
                        var nextEntries = window.performance.getEntries();

                        if (nextEntries.length === entryCache.length) {
                            return;
                        } else if (nextEntries.length > entryCache.length) {
                            var diffEntries = [];
                            for (var index = 0; index < nextEntries.length; index++) {
                                if (entryCache.indexOf(nextEntries[index].name) === -1) {
                                    diffEntries.push(nextEntries[index]);
                                }
                            }
                            entryCache = nextEntries;
                            _this.doHandlePerformanceEntry(diffEntries);
                        }
                    }, 1500);
                });
            }
        }
    }, {
        key: 'handleResourceTiming',
        value: function handleResourceTiming() {
            try {
                if (isSupportGetEntry) {
                    var entries = window.performance.getEntries();
                    this.doHandlePerformanceEntry(entries);
                    this.observePerformanceChange();
                }
            } catch (e) {
                this.errManager.reportSystemError(e);
            }
        }

        /**
         * 解析全局中的资源加载错误
         * 
         * @param {Event} event 
         * @memberof ResManager
         */

    }, {
        key: 'handleResourceLoadError',
        value: function handleResourceLoadError(event) {
            var _this2 = this;

            var target = event.target || event.srcElement;

            //  不再处理window上JS的错误，onerror比此方法兼容性更好
            var doTask = function doTask() {
                var url = target.src || target.href;
                var sec_category = target.nodeName;
                if (sec_category) {
                    sec_category = sec_category.toLowerCase();
                }
                //  过滤图片懒加载(url等于前部分href)触发的error
                var href = Global.getHref();
                if (!href || href.indexOf(url) === 0) {
                    return;
                }

                var urlShort = url;
                if (sec_category === 'img') {
                    urlShort = getImageDomain(url);
                }
                if (!urlShort) return;

                var isUrlUseful = _this2.filterResource(urlShort);
                if (!isUrlUseful) return;

                _this2.addLogan(sec_category, url);

                if (isSupportGetEntry) {
                    _this2.pushApi({
                        type: sec_category,
                        resourceUrl: urlShort,
                        responsetime: 0,
                        responsebyte: 0,
                        statusCode: '500|',
                        firstCategory: Category.RESOURCE,
                        secondCategory: sec_category,
                        logContent: url
                    });
                } else {
                    _this2.errManager._pushResource({
                        category: Category.RESOURCE,
                        sec_category: sec_category,
                        content: url
                    });
                }
            };

            try {
                var isElementTarget = target instanceof HTMLScriptElement || target instanceof HTMLLinkElement || target instanceof HTMLImageElement;
                if (!isElementTarget) return;
                doTask();
            } catch (e) {
                this.errManager.reportSystemError(e);
            }
        }
    }, {
        key: 'addLogan',
        value: function addLogan(type, url) {
            Logan.log('[\u8D44\u6E90\u52A0\u8F7D\u51FA\u9519]: [\u7C7B\u578B]->' + type + ' [\u94FE\u63A5]->' + url);
        }
    }, {
        key: '_stringify',
        value: function _stringify() {
            var cache = this.cache;
            if (!cache || !cache.length) {
                return;
            }
            var ret = [];
            var ext = this.cfgManager.getExtension();
            var extArr = [];

            var extMap = {
                region: 0,
                operator: 1,
                network: 2,
                container: 3,
                os: 4
            };

            for (var key in ext) {
                if (ext.hasOwnProperty(key)) {
                    extArr[extMap[key]] = ext[key];
                }
            }
            ext = 'S\t' + extArr.join('\t');

            ret.push(ext);

            for (var i = 0; i < cache.length; i++) {
                var resource = cache[i];
                ret.push(resource.stringify());
            }
            this.cache = [];
            ret = ret.join('\n');
            return ret;
        }
    }, {
        key: 'doBatchPush',
        value: function doBatchPush(data) {
            data = this.parse(data);
            var batchInst = new RM(data);

            if (this.onPush) {
                this.onPush(batchInst);
            }

            var shouldPushBatch = true;
            var cfgManager = this.cfgManager;

            //  自定义过滤batch规则
            if (typeof cfgManager.get('onBatchPush') === 'function') {
                var onBatchPush = cfgManager.get('onBatchPush');
                try {
                    shouldPushBatch = onBatchPush(batchInst);
                } catch (e) {
                    Logger.ignore(e);
                }
            }

            if (!shouldPushBatch) return;

            this.cache.push(batchInst);
        }
    }, {
        key: 'push',
        value: function push(resource) {

            var cfgManager = this.cfgManager;
            //  控制采样率
            if (Math.random() > cfgManager.get(NAME).sample) return;

            this.doBatchPush(resource);

            if (this.cache.length >= CACHE_SEND_TRIGGER) {
                this.report(true);
            } else {
                this.triggerReport();
            }
        }
    }, {
        key: 'parse',
        value: function parse(resource) {
            if (!resource.pageUrl) {
                resource.pageUrl = this.cfgManager.get('pageUrl');
            }
            if (!resource.project) {
                resource.project = this.cfgManager.get('project');
            }
            return resource;
        }
        /**
         * API上报
         * 
         * @param {Object} api 
         * @memberof ResManager
         */

    }, {
        key: 'pushApi',
        value: function pushApi(api) {
            var cfgManager = this.cfgManager;
            //  控制采样率
            if (Math.random() > cfgManager.get(NAME).sampleApi) return;

            this.doBatchPush(api);
            this.triggerReport();
        }
    }, {
        key: 'report',
        value: function report() {
            this.triggerReport(true);
        }
    }, {
        key: 'triggerReport',
        value: function triggerReport(isReoprtNow) {
            var _this3 = this;

            var cfgManager = this.cfgManager;

            if (!this.cache.length) return;

            var comboReport = function comboReport() {
                clearTimeout(_this3.comboTimeout);
                _this3.comboTimeout = 0;

                if (_this3.onSubmit) {
                    _this3.onSubmit(_this3.cache);
                }

                _this3.send();
            };

            var delay = cfgManager.get(NAME).delay;
            if (isReoprtNow) {
                this.send();
            } else if (!this.comboTimeout && delay !== -1) {
                this.comboTimeout = setTimeout(comboReport, delay);
            }
        }
    }, {
        key: 'send',
        value: function send() {
            if (this.onSubmit) {
                this.onSubmit(this.cache);
            }
            var data = this._stringify();
            if (!data) return;
            var apiPath = this.cfgManager.getApiPath(NAME);
            Ajax({
                type: 'POST',
                url: apiPath,
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: 'c=' + encodeURIComponent(data)
            });
            this.cache = [];
        }
    }]);

    return ResManager;
}();

module.exports = ResManager;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/resource/manager.js
// module id = 253
// module chunks = 0